import React from 'react';
import styles from './styles/styles.module.css';
import { IoMdClose } from 'react-icons/io';
import { FaExpand } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import {
  expand,
  resetCurrentlyOpenLog,
} from '../../Redux/slices/bottomBarSlice';

const TopBar: React.FC<any> = () => {
  const dispatch = useDispatch();
  const { currentlyOpenDescription, expanded } = useSelector(
    (state: any) => state.bottomBar
  );

  return (
    <div className={styles.topBarContainer}>
      <div
        className={!expanded ? styles.topBarLeft : styles.topBarLeftExpanded}
      >
        <p className={styles.topBarDescription}>{currentlyOpenDescription}</p>
      </div>

      <div
        className={!expanded ? styles.topBarRight : styles.topBarRightExpanded}
      >
        <FaExpand
          onClick={() => dispatch(expand())}
          className={styles.expand}
        />
        <IoMdClose
          onClick={() => dispatch(resetCurrentlyOpenLog())}
          className={styles.close}
        />
      </div>
    </div>
  );
};

export default TopBar;
